import K_CollapsableContainer from "../templates/K_CollapsableContainer";
import { Component, ComponentOptions } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface CollapsableContainerOptions extends ComponentOptions {
    components: Component[];
    header: string;
    startOpen?: boolean | "true" | "false";
    style?: string;
    icon?: string;
    text?: string;
    buttonContainer?: string;
    bsc?: string;
}

export class CollapsableContainer extends TemplateComponent {

    options: CollapsableContainerOptions;
    content: {
        components: Component[];
    };

    constructor(options: CollapsableContainerOptions) {
        super(K_CollapsableContainer, options);

        this.content = {
            components: options.components || []
        };
    }

    preRender() {
        const options = this.options;

        options.startOpen = options.startOpen == "false" ? false : options.startOpen;
        options.style = options.style || "";
    }

    create() {
        var cButton = $("#" + this.options.id + "_Button");
        var cBody = $("#" + this.options.id + "_Body");

        if (this.options.startOpen) {
            cBody.slideDown();
            cButton.removeClass("container-collapsed");
        } else {
            cBody.slideUp();
            cButton.addClass("container-collapsed");
        }

        cButton.on("click", function (e) {
            if (!cButton.hasClass("container-collapsed")) {
                cBody.slideUp();
                cButton.addClass("container-collapsed");
            } else {
                cBody.slideDown();
                cButton.removeClass("container-collapsed");
            }
        });
    }

}
